export class Roles {
  public static SETTINGS_READ = 'settings.read'
  public static SETTINGS_WRITE = 'settings.write'

  public static CATEGORY_READ = 'category.read'
  public static CATEGORY_WRITE = 'category.write'
  public static CATEGORY_ADMIN = 'category.admin'

  public static REGISTRATION_READ = 'registration.read'
  public static REGISTRATION_WRITE = 'registration.write'
  public static REGISTRATION_MANAGE = 'registration.manage'
  public static REGISTRATION_ADMIN = 'registration.admin'

  public static CACHE_READ = 'cache.read'
  public static CACHE_WRITE = 'cache.write'

  public static EVENT_READ = 'event.read'
  public static EVENT_WRITE = 'event.write'
  public static EVENT_ADMIN = 'event.admin'
  public static EVENT_MODERATOR = 'event.mod'

  public static ACCOUNT_READ = 'account.read'
  public static ACCOUNT_WRITE = 'account.write'
  public static ACCOUNT_ADMIN = 'account.admin'

  public static MAIL_READ = 'mail.read'
  public static MAIL_WRITE = 'mail.write'

  public static BACKOFFICE_ACCESS = 'backoffice.access'
  public static PERMISSION_EXPORT = 'export'

  public static HISTORY_READ = 'history.read'
  public static HISTORY_ADMIN = 'history.admin'

  public static PROFILE_READ = 'profile.read'
  public static PROFILE_WRITE = 'profile.write'
  public static PROFILE_ADMIN = 'profile.admin'

  public static ADDRESS_READ = 'address.read'
  public static ADDRESS_WRITE = 'address.write'

  public static ACTIVITY_READ = 'activity.read'
  public static ACTIVITY_WRITE = 'activity.write'

  public static FEEDBACK_WRITE = 'feedback.write'

  public static EXPORT_ADMIN = 'export.admin'
}
